import classnames from "classnames";
import { Tooltip } from 'react-bootstrap';
import { FormattedMessage } from "react-intl";
import { DateTime } from 'luxon';
import DigiraatiRelativeTime from "../../../../../../common/DigiraatiRelativeTime";


const CommentAuthorAndDate = ({
  isOwnComment,
  isAuthorAdminUser,
  commentData,
}) => {

  /**
   * User DateTime to convert current timestamp to desired format.
   * @returns {String}
   */
  const parseTimestamp = (timestamp) => DateTime.fromISO(timestamp).toFormat('dd.MM.yyyy HH:mm');

  const dateTooltip =(
    <Tooltip id="comment-date-tooltip">
      {parseTimestamp(commentData.created_at)}
    </Tooltip>
  );

  return (
    <div className='hearing-comment-author-and-date'>
      <address
        className={classnames(
          'hearing-comment-author',
          {
          'hearing-comment-author-own': isOwnComment,
        })}
      >
        <div className="hearing-comment-author-username">
          {commentData.author_name || <FormattedMessage id="anonymous" />}
          {isOwnComment && <span className="sr-only"><FormattedMessage id="ownComment" /></span> }
        </div>
        {isAuthorAdminUser && (
          <div className='hearing-comment-author-organization'>
            ({commentData.organization})
          </div>
        )}
      </address>
        <time className="hearing-comment-date" title={parseTimestamp(commentData.created_at)} >
          <DigiraatiRelativeTime date={new Date(commentData.created_at)} />
        </time>
    </div>
  )
}

export default CommentAuthorAndDate;